import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  Container, Icon,
} from '../../ui-kit';
import { Gallery } from '..';
import './styles.scss';

import languages from '../../constants/languages';

const User = (props) => {
  const [userAge, setUserAge] = useState();
  const createNewArrayForGallery = (photos, avatar) => {
    const newArray = [];
    if (avatar) {
      newArray.push({ src: avatar });
    }
    for (let i = 0; i < photos.length; i += 1) {
      newArray.push({ src: photos[i].uri });
    }
    return newArray;
  };

  const checkAge = (date) => {
    const today = new Date();
    const birthDate = new Date(date);
    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age = -1;
    }
    return age;
  };

  useEffect(() => {
    if (props.age) {
      setUserAge(checkAge(props.age));
    }
  }, [props.age]);

  return (
    <Container className="current_user__container">
      <div className="current_user_basic">
        {props.freelanceBrand && (
          <div className="freelace_brand__container">
            Freelace brand
          </div>
        )}
        <div
          style={{
            backgroundImage: `url(${props.avatar ? props.avatar : require('../../images/background.png')})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
          className="current_user_background"
        />
        <div className="current_user_data__block">
          <div
            style={{
              backgroundImage: `url(${props.avatar})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundColor: 'rgba(77, 204, 197, 0.1)',
            }}
            className="current_user_avatar"
          >
            {!props.avatar && (<Icon name="camera" />)}
          </div>
          <div>
            {(props.lastName || props.name) && (
              <span className="current_user_fullname">
                {props.name}
                {' '}
                {props.lastName}
              </span>
            )}
            {userAge && userAge > 0 ? (
              <span className="current_user_data">
                Age:
                {' '}
                {userAge}
              </span>
            ) : null}
            {props.gender && (
              <span className="current_user_data">
                Gender:
                {' '}
                {props.gender}
              </span>
            )}
            {props.country && (
              <span className="current_user_data">
                Country:
                {' '}
                {props.country}
              </span>
            )}
            {props.phone && (
              <span className="current_user_data">
                phone:
                {' '}
                {props.phone}
              </span>
            )}
            {props.email && (
              <span className="current_user_data">
                Email:
                {' '}
                {props.email}
              </span>
            )}
            {props.position && (
              <span className="current_user_data">
                Position:
                {' '}
                {props.position}
              </span>
            )}

            {props.type === 'company' && props.representativeData && (
              <div className="representative_link_container">
                <span className="current_user_data">Representative:&nbsp;</span>

                <Link to={`/user#${props.representativeData.uid}`} className="representative_link">
                  {`${props.representativeData.name}${' '}
                  ${props.representativeData.lastname ? props.representativeData.lastname : ''}`}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {props.description && (
      <div className="user_description__container">
        <span className="user__title">
          {props.type === 'company' ? 'Company' : 'User'}
          {' '}
          description
        </span>
        <span>{props.description}</span>
      </div>
      )}

      {props.type === 'company' && (
        <>
          {props.addresses.length > 0 && (
            <div className="user_description__container">
              <span className="user__title">Company addresses</span>
              <div className="user_badge__container">
                <ul className="list_of_some_data">
                  {props.addresses.map((e) => (
                    <li>
                      {`${e.address?.en?.country ? e.address.en.country : e.en?.country ? e.en.country : e.country}${e.address?.en?.city || e.en?.city || e.city ? ',' : ''} ${e.address?.en?.city ? e.address.en.city : e.en?.city ? e.en.city : e.city}${
                        e.region ? ', ' : ''
                      } ${e.region}${e.street ? ',' : ''} ${e.street} ${
                        e.house
                      } ${e.office}`}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {props.links.length > 0 && (
            <div className="user_description__container">
              <span className="user__title">Company links</span>
              <div className="user_badge__container">
                <ul className="list_of_some_data">
                  {props.links.map((e) => (
                    <li>
                      <Link to={e.link} className="link_text">
                        <span>{e.link}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </>
      )}

      {props.interest && (
      <div className="user_description__container">
        <span className="user__title">Kind of activity</span>
        <div className="user_badge__container">
          {props.interest.map((item) => (
            <div className="user_badge_item">{item.enName}</div>
          ))}
        </div>
      </div>
      )}
      {(props.height
        || props.weight
        || props.breast
        || props.waist
        || props.thigh) && (
        <div className="user_description__container">
          <span className="user__title">Physical characteristics</span>
          <div className="user_badge__container">
            {props.height && (
              <div className="user_item">
                Height:
                {' '}
                {props.height}
                cm
              </div>
            )}
            {props.weight && (
              <div className="user_item">
                Weight:
                {' '}
                {props.weight}
                kg
              </div>
            )}
            {props.breast && (
              <div className="user_item">
                Breast size:
                {' '}
                {props.breast}
              </div>
            )}
            {props.waist && (
              <div className="user_item">
                Waist:
                {' '}
                {props.waist}
                cm
              </div>
            )}
            {props.thigh && (
              <div className="user_item">
                Thigh:
                {' '}
                {props.waist}
                cm
              </div>
            )}
            {props.shoeSize && (
              <div className="user_item">
                Shoe size:
                {' '}
                {props.shoeSize}
              </div>
            )}
            {props.clothingSize && (
              <div className="user_item">
                Сlothing size:
                {' '}
                {props.clothingSize}
              </div>
            )}
          </div>
        </div>
      )}
      {(props.appearanceType || props.hairСolor) && (
        <div className="user_description__container">
          <span className="user__title">Features of appearance</span>
          <div className="user_badge__container">
            {props.appearanceType && (
            <div className="user_item">
              Appearance type:
              {' '}
              {props.appearanceType}
            </div>
            )}
            {props.hairСolor && (
            <div className="user_item">
              Hair color:
              {' '}
              {props.hairСolor}
            </div>
            )}
          </div>
        </div>
      )}

      {props.languages && (
        <div className="user_description__container">
          <span className="user__title">Languages</span>
          <div className="user_badge__container">
            {props.languages.map((item) => (
              <div className="offer_item offer_dropdown_item">
                <span>{item.customName ? item.customName : languages[item.id]}</span>
                <div className="offer_dropdown__block">
                  <Icon name="info" />
                </div>
                <div className="offer_dropdown__container">
                  <Icon name="triangle" />
                  <span>{item.level}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {(props.photos.length > 0 || props.avatar) && (
        <div>
          <span className="user__title">
            {props.type === 'company' ? 'Company' : 'User'}
            {' '}
            photos
          </span>
          <Gallery images={createNewArrayForGallery(props.photos, props.avatar)} />
        </div>
      )}

    </Container>
  );
};

User.propTypes = {
  type: PropTypes.string,
  photos: PropTypes.array,
  interest: PropTypes.array,
  name: PropTypes.string,
  lastName: PropTypes.string,
  avatar: PropTypes.string,
  description: PropTypes.string,
  gender: PropTypes.string,
  height: PropTypes.string,
  weight: PropTypes.string,
  breast: PropTypes.string,
  waist: PropTypes.string,
  thigh: PropTypes.string,
  languages: PropTypes.array,
  appearanceType: PropTypes.string,
  clothingSize: PropTypes.string,
  shoeSize: PropTypes.string,
  hairСolor: PropTypes.string,
  country: PropTypes.string,
  age: PropTypes.string,
  position: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  addresses: PropTypes.array,
  links: PropTypes.array,
  representativeData: PropTypes.object,
  freelanceBrand: PropTypes.bool,
};
User.defaultProps = {
  freelanceBrand: false,
  representativeData: null,
  links: [],
  addresses: [],
  type: 'user',
  photos: [],
  position: null,
  email: null,
  interest: null,
  phone: null,
  name: null,
  lastName: null,
  avatar: null,
  description: null,
  gender: null,
  height: null,
  weight: null,
  breast: null,
  waist: null,
  thigh: null,
  languages: null,
  appearanceType: null,
  clothingSize: null,
  shoeSize: null,
  hairСolor: null,
  country: null,
  age: null,
};

export default User;
